var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(false)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.testThumbnail()}}},[_vm._v("Test thumbnail generation")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }